module.exports = __webpack_public_path__ + "static/mentor-vedushi-0da63bb2958639b07a6a58db84e5a40c.png";